<template>
  <div class="container_reject">
    <el-dialog
      class="default-dialog"
      title="驳回原因"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content-max" v-loading="loading">
        <div class="item-wrap" v-for="(item,i) in list" :key="i">
          <div class="item-box">
            <div class="item-box-text">账期：</div>
            <el-input v-model="item.yearPeriods" size="small" style="width:300px" disabled placeholder="请输入"></el-input>
          </div>
          <div class="item-box">
            <div class="item-box-text"><span style="color:red">*</span>驳回原因：</div>
            <div>
              <el-input 
                type="textarea" 
                :autosize="{ minRows: 3, maxRows: 5}" 
                placeholder="请输入" 
                v-model="item.reason"
                size="small"
                style="width:300px"
                maxlength="200"
                show-word-limit>
              </el-input>
              <span v-if="item.isReason" style="color:red;display: block;font-size: 12px;">请填写驳回原因</span>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" align="center">
        <el-button size="small" style="width: 100px;" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" style="width: 100px;background: #269D7B;color: #fff;" @click="handleConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { examineReject } from '@/api'
export default {
  components: {},
  props: {},
  created() {},
  data() {
    return {
      loading: false,
      dialogVisible: false,
      list: [],
      textarea: ''
    }
  },
  methods: {
    handleOpen(list) {
      console.log(list);
      const ret = list.map(x => {
        return {
          id: x.id,
          yearPeriods: x.yearPeriods,
          reason: '',
          isReason: true,
        }
      })
      this.list = ret
      this.dialogVisible = true
    },
    handleConfirm() {
      this.list.forEach(x => x.isReason = !!!x.reason)
      const check = this.list.every(x => !x.isReason)
      if(!check) { return this.$message.error('请填写驳回原因') }
      this.rejectConfirm()
    },
    // 驳回
    async rejectConfirm() {
      try {
        this.loading = true
        const { data } = await examineReject({
          list: this.list,
          cid: JSON.parse(sessionStorage.getItem("cid"))
        })
        if(data.code == 1) {
          this.$emit("rejectConfirm")
          this.dialogVisible = false
        }
      } catch (error) {
        this.loading = false
      }
      this.loading = false
    }
  }
}
</script>

<style lang='less' scoped>
.content-max {
  max-height: 600px;
  overflow: auto;
  .item-wrap {
    padding: 20px 0 20px 10px;
    border-bottom: 1px solid #F6F8FA;
    &:first-child {
      padding-top: 0px;
    }
    &:last-child {
      border: none;
    }
    .item-box {
      display: flex;
      align-items: center;
      white-space: nowrap;
      &:first-child {
        margin-bottom: 20px;
      }
      &-text {
        width: 100px;
        text-align: right;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/examine/components/RejectDetail.vue